import src from "./how-2.jpg";
export default { src: src, aspect: 1.8400, width: 736, height: 400 };